import { Injectable } from '@angular/core';
import { Observable, of, tap } from 'rxjs';

import { IAppointmentSlot } from '../models/public-provider-calendar.interface';
import { ProviderCalendarHttpService } from '../services/provider-calendar.httpservice';

@Injectable({
  providedIn: 'root'
})
export class ProviderCalendarStore {
  private cachedAppointmentSlots: IAppointmentSlot[] | undefined;

  constructor(private providerCalendarHttpService: ProviderCalendarHttpService) {}

  getAppointmentSlots$(
    providerPersonaId: number,
    providerTimeZone: string,
    forceRefresh = false
  ): Observable<IAppointmentSlot[]> {
    if (!forceRefresh && this.cachedAppointmentSlots) {
      return of(this.cachedAppointmentSlots);
    }

    return this.providerCalendarHttpService.getAppointmentSlots$(providerPersonaId, providerTimeZone).pipe(
      tap((slots) => {
        this.cachedAppointmentSlots = slots;
      })
    );
  }
}
